import React from 'react';
import {BrowserRouter as Router} from 'react-router-dom';
import Page from "./components/router/Router";
import {DataProvider} from './GlobalState';

function App() {
  return (
    <DataProvider>
      <Router>
        <div className="">
          <Page/>
        </div>
      </Router>
    </DataProvider>
  );
}

export default App;
